import axios from "axios";
import React, { useEffect, useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Swal from "sweetalert2";
import { baseUrl, userName, ipAddress } from './Univ.js';

function AddHouse() {
  const [streets, setStreets] = useState([]);
  const [rows, setRows] = useState([]);

  const [form, setForm] = useState({
    street: "",
    house_no: "",
    family_head: "",
    total_voters: "",
    contact_no: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

const formSubmit = () => {
  // Validation
  if (!form.street || !form.house_no) {
    Swal.fire('Error', 'Street & House No are required', 'error');
    return;
  }

  // Create FormData
  const _formData = new FormData();
  _formData.append('street', form.street);
  _formData.append('house_no', form.house_no);
  _formData.append('family_head', form.family_head);
  _formData.append('total_voters', form.total_voters);
  _formData.append('contact_no', form.contact_no);
  _formData.append('status', '1');
  _formData.append('addedby', userName);
  _formData.append('ip_add', ipAddress);

  // POST request
  axios.post(baseUrl + 'houses/', _formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  })
  .then(response => {
    if (response.status === 200 || response.status === 201) {
      Swal.fire({
        title: 'House has been added',
        icon: 'success',
        timer: 3000,
        showConfirmButton: false
      });

       // refresh list
        setTimeout(() => window.location.reload(), 1000);
      // Reset form
      setForm({
        street: '',
        house_no: '',
        family_head: '',
        total_voters: '',
        contact_no: '',
        status: 1,
        addedby: userName,
        ip_add: ipAddress
      });
    }
  })
  .catch(error => {
    console.error(error.response?.data || error);
    Swal.fire('Error', 'Failed to add house', 'error');
  });
};

  const fetchHouses = () => {
    axios.get(baseUrl + "houses/").then((res) => setRows(res.data));
  };

  const fetchStreets = () => {
    axios.get(baseUrl + "streets/").then((res) => setStreets(res.data));
  };

  const deleteRow = (id) => {
    Swal.fire({ title: "Delete?", showCancelButton: true }).then((r) => {
      if (r.isConfirmed) {
        axios.delete(baseUrl + "houses/" + id + "/").then(fetchHouses);
      }
    });
  };

  useEffect(() => {
    fetchStreets();
    fetchHouses();
  }, []);

  const columns = [
    { field: "id", width: 80 },
    {
      field: "street",
      headerName: "Street",
      width: 200,
      renderCell: (p) => p.row.street?.name,
    },
    { field: "house_no", headerName: "House No", width: 120 },
    { field: "family_head", width: 180 },
    { field: "total_voters", width: 120 },
    { field: "contact_no", width: 150 },
    {
      field: "actions",
      width: 120,
      renderCell: (p) => (
        <button className="btn btn-danger btn-sm" onClick={() => deleteRow(p.row.id)}>
          Delete
        </button>
      ),
    },
  ];

  return (
    <section className="container mt-4">
  <div className="card">
    <h4 className="card-header">Add House</h4>

    <div className="card-body">
      {/* Street */}
      <div className="mb-3">
        <label className="form-label">Street</label>
        <select
          name="street"
          value={form.street}
          onChange={handleChange}
          className="form-control"
        >
          <option value="">-- Select Street --</option>
          {streets.map((s) => (
            <option key={s.id} value={s.id}>
              {s.name}
            </option>
          ))}
        </select>
      </div>

      {/* House No */}
      <div className="mb-3">
        <label className="form-label">House No</label>
        <input
          type="text"
          name="house_no"
          value={form.house_no}
          onChange={handleChange}
          className="form-control"
          placeholder="Eg: 12B"
        />
      </div>

      {/* Family Head */}
      <div className="mb-3">
        <label className="form-label">Family Head</label>
        <input
          type="text"
          name="family_head"
          value={form.family_head}
          onChange={handleChange}
          className="form-control"
          placeholder="Eg: Ramesh Kumar"
        />
      </div>

      {/* Total Voters */}
      <div className="mb-3">
        <label className="form-label">Total Voters</label>
        <input
          type="number"
          name="total_voters"
          value={form.total_voters}
          onChange={handleChange}
          className="form-control"
        />
      </div>

      {/* Contact No */}
      <div className="mb-3">
        <label className="form-label">Contact No</label>
        <input
          type="text"
          name="contact_no"
          value={form.contact_no}
          onChange={handleChange}
          className="form-control"
          placeholder="Eg: 9876543210"
        />
      </div>

      <button className="btn btn-primary" onClick={formSubmit}>
        Save House
      </button>
    </div>
  </div>

  {/* DataGrid */}
  <div className="mt-4">
    <DataGrid
      rows={rows}
      columns={columns}
      pageSize={25}
      rowsPerPageOptions={[25, 50, 100]}
      components={{ Toolbar: GridToolbar }}
      autoHeight
      sx={{
        boxShadow: 4,
        border: 4,
        borderColor: 'primary.light',
        '& .MuiDataGrid-cell:hover': {
          color: 'primary.main'
        }
      }}
    />
  </div>
</section>

  );
}

export default AddHouse;
